export default "__VITE_ASSET__CFNqb9Wk__"